import { render, staticRenderFns } from "./newPurchase.vue?vue&type=template&id=58edbe82&scoped=true"
import script from "./newPurchase.vue?vue&type=script&lang=js"
export * from "./newPurchase.vue?vue&type=script&lang=js"
import style0 from "./newPurchase.vue?vue&type=style&index=0&id=58edbe82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58edbe82",
  null
  
)

export default component.exports